module.exports = __webpack_public_path__ + "img/Loading_r_38.f730d86c.png";